import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  Input,
  Inject,
  OnInit,
  Component,
  HostBinding,
  ChangeDetectionStrategy,
} from '@angular/core';

import { ISnBrandLogosConfig } from '../../interfaces/brand-logos-config.interface';
import { SN_BRAND_LOGOS } from '../../providers/brand-logos.provider';
import { SN_BRAND_NAME } from '../../providers/brand-name.provider';
import { SnBrandLogoSize } from '../../types/brand-logo-size.type';
import { SnBrandLogoType } from '../../types/brand-logo-type.type';

@Component({
  selector: 'sn-brand-logo, [snBrandLogo]',
  template: '<img [src]="logoUrl" [alt]="name" />',
  styleUrls: ['./brand-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-brand-logo',
  },
})
export class SnBrandLogoComponent implements OnInit {
  @Input()
  set type(value: SnBrandLogoType) {
    this._type = value;
    this._updateLogoUrl();
  }

  @Input()
  set inverse(value: boolean) {
    this._inverse = coerceBooleanProperty(value);
    this._updateLogoUrl();
  }

  @Input() public size: SnBrandLogoSize;

  public logoUrl: string;

  @HostBinding('class.sn-brand-logo_inverse')
  private _inverse: boolean;

  private _type: SnBrandLogoType;

  constructor(
    @Inject(SN_BRAND_NAME) public readonly name: string,
    @Inject(SN_BRAND_LOGOS) private readonly _logos: ISnBrandLogosConfig,
  ) {
    this.type = 'icon';
    this.size = 'md';
  }

  @HostBinding('class.sn-brand-logo_icon')
  get isIconLogo(): boolean {
    return this._type === 'icon';
  }

  @HostBinding('class.sn-brand-logo_vertical')
  get isVerticalLogo(): boolean {
    return this._type === 'vertical';
  }

  @HostBinding('class.sn-brand-logo_horizontal')
  get isHorizontalLogo(): boolean {
    return this._type === 'horizontal';
  }

  @HostBinding('class.sn-brand-logo_xsm')
  get isExtraSmallSize(): boolean {
    return this.size === 'xsm';
  }

  @HostBinding('class.sn-brand-logo_sm')
  get isSmallSize(): boolean {
    return this.size === 'sm';
  }

  @HostBinding('class.sn-brand-logo_md')
  get isMediumSize(): boolean {
    return this.size === 'md';
  }

  @HostBinding('class.sn-brand-logo_lg')
  get isLargeSize(): boolean {
    return this.size === 'lg';
  }

  public ngOnInit(): void {
    this._updateLogoUrl();
  }

  private _updateLogoUrl(): void {
    let configKey: keyof ISnBrandLogosConfig = this._type;

    if (this._inverse) {
      configKey += 'Inverse';
    }

    this.logoUrl = this._logos[configKey];
  }
}
